import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/index.scss'
import store from './store'
import _ from 'lodash'

Vue.config.productionTip = false

Vue.filter('humanize', function (value) {
    if (!value) return '';
    return _.startCase(value);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
